<template>
    <v-snackbar
      v-model="isVisible"
      :color="status"
      location="bottom right"
    >
      <div v-for="text in textArray"
           :key="text">
        {{ text }}
      </div>
    </v-snackbar>
</template>

<script setup lang="ts">

import {ref} from "vue";
import type {PropType} from "vue";

const props = defineProps({
  status: {
    required: true,
    type: String as PropType<string>,
  },
  textArray: {
    required: true,
    type: Array as PropType<string[]>
  },
});

const isVisible = ref<boolean>(false);
const show = () => {
  isVisible.value = true;
}

defineExpose({
  show,
})

</script>

